import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AclDataModule } from '../acl-data/acl-data.module';
import { AngularMaterialModule } from '../angular-material.module';
import { BusinessOwnerListComponent } from './business-owner-list/business-owner-list.component';
import { BusinessOwnerEditComponent } from './business-owner-edit/business-owner-edit.component';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { FileUploadModule } from 'ng2-file-upload';
import { BOUploadComponent } from './bo-upload/bo-upload.component';

@NgModule({
    declarations: [
        BusinessOwnerListComponent,
        BusinessOwnerEditComponent,
        BOUploadComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AngularMaterialModule,
        AclDataModule,
        RouterModule.forChild([]),
        SharedControlsModule,
        FileUploadModule,
    ],
    exports: [BusinessOwnerListComponent],
    entryComponents: [BOUploadComponent],
})
export class BusinessOwnerModule {}
